module.exports = __webpack_public_path__ + "0cf2f82e6a503d00ac11c617e0b4a476.pdf";